import type { Infer } from 'superstruct';
import { assign, object, string } from 'superstruct';

import { IdObjectWithName } from '@adflow/shared/util-superstruct';

export const HistoryFacebookAdAccountDto = assign(
	IdObjectWithName,
	object({ avbId: string() })
);

export type HistoryFacebookAdAccountDto = Infer<
	typeof HistoryFacebookAdAccountDto
>;
